export default "__VITE_ASSET__b405db0c__"